module.exports = __webpack_public_path__ + "static/img/step_4-choose-button.9fd37a97.png";